import { render, staticRenderFns } from "./ClienteSolicitudIndex.vue?vue&type=template&id=36f2e9d6"
import script from "./ClienteSolicitudIndex.vue?vue&type=script&lang=js"
export * from "./ClienteSolicitudIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports